import { gql } from '@apollo/client';

const SIGNUP = gql`
  mutation signup($fullname: String!, $username: String!, $email: String!, $password: String!) {
    signup(fullname: $fullname, username: $username, email: $email, password: $password) {
      id
      fullname
      username
      email
      role
      following {
        id
        fullname
        username
      }
      followers {
        id
        fullname
        username
      }
      token
      link
      profileImg
      coverImg
      createdAt
    }
  }
`;

const LOGIN = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      id
      fullname
      username
      email
      role
      following {
        id
        fullname
        username
      }
      followers {
        id
        fullname
        username
      }
      token
      link
      profileImg
      coverImg
      createdAt
    }
  }
`;

const GET_USER_PROFILE = gql`
  mutation getUserProfile($id: ID!) {
    userProfile(id: $id) {
      id
      fullname
      username
      email
      link
      role
      following {
        id
        fullname
        username
      }
      followers {
        id
        fullname
        username
      }
      profileImg
      coverImg
      createdAt
    }
  }
`;

const FOLLOW_UNFOLLOW_USER = gql`
  mutation followUnfollowUser($id: ID!, $toId: ID!) {
    followUnfollowUser(id: $id, toId: $toId) {
      id
      fullname
      username
      email
      link
      role
      following {
        id
        fullname
        username
      }
      followers {
        id
        fullname
        username
      }
      profileImg
      coverImg
      createdAt
    }
  }
`;

const SAVE_POST = gql`
  mutation savePost($userId: ID!, $postId: ID!) {
    savePost(userId: $userId, postId: $postId)
  }
`

const UPDATE_USER = gql`
  mutation updateUser($id: ID!, $fullname: String, $username: String, $email: String, $currentPassword: String, $newPassword: String, $profileImg: String, $coverImg: String, $link: String) {
    updateUser(id: $id, fullname: $fullname, username: $username, email: $email, currentPassword: $currentPassword, newPassword: $newPassword, profileImg: $profileImg, coverImg: $coverImg, link: $link) {
      id
      fullname
      username
      email
      link
      role
      following {
        id
        fullname
        username
      }
      followers {
        id
        fullname
        username
      }
      profileImg
      coverImg
      createdAt
    }
  }
`;

const DELETE_USER = gql`
  mutation deleteUser($id: ID!) {
    deleteUser(id: $id) {
      id
      fullname
      username
      email
    }
  }
`;

export { SIGNUP, LOGIN, GET_USER_PROFILE, FOLLOW_UNFOLLOW_USER, SAVE_POST, UPDATE_USER, DELETE_USER };
